import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'User Research',
                topics: [
                    'Using AI for automated user surveys to collect and analyze user feedback',
                    'AI-based heat maps to identify patterns in user interactions with websites or products',
                    'Using AI-powered eye-tracking for studying user behavior and preferences',
                    'AI-driven usability testing for evaluating user experience',
                    'Using AI for emotion detection to better understand user behavior',
                ],
            },
            {
                title: 'Usability',
                topics: [
                    'Using AI for personalized user interfaces to improve usability',
                    'AI-powered predictive text for faster and easier user input',
                    'AI for predicting and preventing user errors',
                    'AI-based voice user interfaces to improve usability and accessibility',
                ],
            },
            {
                title: 'Visual Design',
                topics: [
                    'Using AI for image recognition and categorization in visual design',
                    'AI-powered color scheme generators for visual design',
                    'AI-based layout optimization for visual design',
                    'Using AI for logo design and customization',
                    'AI-based typography analysis and customization in visual design',
                ],
            },
            {
                title: 'Web and Apps Design',
                topics: [
                    'AI for recommending new or improved features for applications',
                    'AI-driven automated testing to ensure the quality of applications',
                    'Using AI for predicting user behavior and needs in applications',
                    'AI-based performance optimization for applications',
                    'Using AI for personalized website experiences based on user data',
                    'AI-based automated website layout design to improve user experience',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;